var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('el-container',{staticClass:"container"},[_c('Nav'),_c('el-container',{staticClass:"main-box"},[_c('el-main',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }